module.exports = __webpack_public_path__ + "static/2-e14e81519c2ac512d73f8a2d76838058.jpeg";